import { render, staticRenderFns } from "./ValidationCard.vue?vue&type=template&id=5b91f251&"
import script from "./ValidationCard.vue?vue&type=script&lang=js&"
export * from "./ValidationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports